module.exports = __webpack_public_path__ + "media/mushroom.94765343.mp3";